import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TooltipRowContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-family: Inter;
  font-weight: 400;
  color: ${colors.text['main-900']};
`;

export const Title = styled.strong`
  font-size: 12px;
  font-family: Inter;
  font-weight: 700;
  color: ${colors.text['main-900']};
`;
